import { useState } from "react";

const getHeaders = () => ({ piak: localStorage.getItem("piak") });
const getUser = () => JSON.parse(localStorage.getItem("user"));

export default function useAuth() {
  const [headers, setHeaders] = useState(getHeaders());
  const [user, setUser] = useState(getUser());
  const isAuthenticated = !!user && !!headers?.piak;

  const saveAuth = (authResponse) => {
    const {
      data: { data },
      headers,
    } = authResponse;
    const piak = headers.piak;

    const v3user = {
      id: data.id,
      type: data.user_type,
      name: data.name,
      total_trades: data.total_trades,
      sign_in_counts: data.sign_in_counts,
      current_sign_in_at: data.current_sign_in_at,
      last_signed_in_at: data.last_signed_in_at,
      currrent_ip: data.currrent_ip,
      email: data.email,
      nickname: data.nickname,
      avatar: data.image,
      modules: data.enabled_modules,
      products: data.available_products,
      client_users: data.client_users,
      client_name: data.client_name,
      configs: data.configs,
    };

    localStorage.setItem("user", JSON.stringify(v3user));
    localStorage.setItem("piak", piak);

    setHeaders({ piak });
    setUser(data.data);
  };

  const deleteAuth = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("piak");

    setHeaders(undefined);
    setUser(undefined);
  };

  return {
    setAuth: saveAuth,
    authHeaders: headers,
    user,
    deleteAuth,
    isAuthenticated,
  };
}
